// DO NOT MODIFY THIS FILE GENERATED BY YARN

import * as React from "react";

const iconList = ["logo"];

interface IconProps {
  color?: string;
  className?: string;
  height?: number;
  kind?: string | any;
  onClick?: () => void;
  preview?: boolean;
  size?: number;
  style?: any;
  width?: number;
  wrapperStyle?: any;
}
export default class Icon extends React.Component<IconProps, {}> {
  static defaultProps = {
    className: "",
    color: "currentColor",
    size: 32,
  };

  render() {
    const { kind, preview } = this.props;
    return preview ? this.renderPreview() : this.renderIcon(kind);
  }

  renderPreview() {
    return <div className="w-auto flex flex-wrap">{iconList.map((kind) => this.renderPreviewKind(kind))}</div>;
  }

  renderIcon(kind: string) {
    const { wrapperStyle } = this.props;
    if (wrapperStyle) {
      return <div style={wrapperStyle}>{this.getIcon(kind)}</div>;
    }
    return this.getIcon(kind);
  }

  renderPreviewKind(kind: string) {
    return (
      <div key={kind} className="w-1/4 px-2">
        <div className="p-4 my-2 bg-purple-100 text-purple-700 text-center rounded">
          <p className="mb-3 flex justify-center">{this.renderIcon(kind)}</p>
          <p>
            <small>&lt;Icon kind="{kind}" /&gt;</small>
          </p>
        </div>
      </div>
    );
  }

  getIcon(kind: string) {
    const { color, height, onClick, size, style, width, className, ...rest } = this.props;

    switch (kind) {
      case "logo":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            fill={color}
            viewBox="0 0 50 36"
          >
            <path
              d="M47.498 3.33 1.715 15.57l11.288 6.48 1.986 9.99 6.322-5.31 9.391 5.49L47.498 3.33ZM34.315 9.36 14.086 19.89l-5.96-3.51 26.188-7.02Zm-17.79 18.18-1.083-5.58 20.228-10.44-15.352 12.87-3.793 3.15Zm6.683-2.43 17.067-14.4L29.8 28.89l-6.592-3.78Z"
              fill="url(#a)"
            />
            <defs>
              <linearGradient id="a" x1={11.957} y1={29.967} x2={36.09} y2={-4.615} gradientUnits="userSpaceOnUse">
                <stop offset={0.15} stopColor="#10B857" />
                <stop offset={0.21} stopColor="#11B868" />
                <stop offset={0.399} stopColor="#13B898" />
                <stop offset={0.578} stopColor="#15B7BE" />
                <stop offset={0.743} stopColor="#17B7D9" />
                <stop offset={0.889} stopColor="#18B7E9" />
                <stop offset={1} stopColor="#18B7EF" />
              </linearGradient>
            </defs>
          </svg>
        );
      case "search":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            fill={color}
            viewBox="0 0 24 24"
          >
            <g clipPath="url(#a)">
              <path
                d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5Zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14Z"
                fill={color || "#fff"}
              />
            </g>
            <defs>
              <clipPath id="a">
                <path fill={color || "#fff"} d="M0 0h24v24H0z" />
              </clipPath>
            </defs>
          </svg>
        );

      case "technology":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.7143 0.571411H2.14286C1.51167 0.571411 1 1.08309 1 1.71427V14.2857C1 14.9169 1.51167 15.4286 2.14286 15.4286H14.7143C15.3455 15.4286 15.8571 14.9169 15.8571 14.2857V1.71427C15.8571 1.08309 15.3455 0.571411 14.7143 0.571411Z"
              stroke="#0B93DF"
              strokeWidth="1.14286"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1 4.57141H15.8571M5.57143 7.99998L3.85714 9.71427L5.57143 11.4286M11.8571 7.99998L13.5714 9.71427L11.8571 11.4286M7.85714 12L9.57143 6.85713"
              stroke="#0B93DF"
              strokeWidth="1.14286"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );

      case "industry":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            viewBox="0 0 18 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.46148 1.23077V14.7692H9.84608V1.23077H2.46148ZM1.8461 0H10.4615C10.6247 0 10.7812 0.0648348 10.8966 0.180242C11.012 0.295648 11.0768 0.452173 11.0768 0.615383V15.3846C11.0768 15.5478 11.012 15.7043 10.8966 15.8197C10.7812 15.9351 10.6247 16 10.4615 16H1.8461C1.68289 16 1.52636 15.9351 1.41095 15.8197C1.29555 15.7043 1.23071 15.5478 1.23071 15.3846V0.615383C1.23071 0.452173 1.29555 0.295648 1.41095 0.180242C1.52636 0.0648348 1.68289 0 1.8461 0Z"
              fill="#0B93DF"
            />
            <path
              d="M3.6923 3.69238H8.61537V4.92315H3.6923V3.69238ZM3.6923 7.38468H8.61537V8.61545H3.6923V7.38468ZM3.6923 11.077H8.61537V12.3077H3.6923V11.077ZM11.0769 8.61545H13.5384V9.84622H11.0769V8.61545ZM11.0769 11.077H13.5384V12.3077H11.0769V11.077ZM0 14.7693H17.2307V16H0V14.7693Z"
              fill="#0B93DF"
            />
            <path
              d="M11.077 6.15362V14.769H14.7693V6.15362H11.077ZM10.4616 4.92285H15.3846C15.5479 4.92285 15.7044 4.98769 15.8198 5.10309C15.9352 5.2185 16 5.37503 16 5.53823V15.3844C16 15.5476 15.9352 15.7041 15.8198 15.8195C15.7044 15.9349 15.5479 15.9998 15.3846 15.9998H10.4616C10.2984 15.9998 10.1418 15.9349 10.0264 15.8195C9.91103 15.7041 9.84619 15.5476 9.84619 15.3844V5.53823C9.84619 5.37503 9.91103 5.2185 10.0264 5.10309C10.1418 4.98769 10.2984 4.92285 10.4616 4.92285Z"
              fill="#0B93DF"
            />
          </svg>
        );

      case "trophy":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M41.1818 26.5455C41.1818 34.6182 35.5964 42.1673 28.0909 44C20.5855 42.1673 15 34.6182 15 26.5455V17.8182L28.0909 12L41.1818 17.8182V26.5455ZM28.0909 41.0909C33.5455 39.6364 38.2727 33.1491 38.2727 26.8655V19.7091L28.0909 15.1709L17.9091 19.7091V26.8655C17.9091 33.1491 22.6364 39.6364 28.0909 41.0909ZM32.5273 33.8182L28.0473 31.1273L23.5818 33.8182L24.76 28.7273L20.8182 25.3236L26.0255 24.8727L28.0473 20.0727L30.0836 24.8582L35.2909 25.3091L31.3345 28.7273L32.5273 33.8182Z"
              fill="#18B7E9"
            />
          </svg>
        );

      case "outline-trending":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            viewBox="0 0 56 56"
            fill="none"
          >
            <path
              d="M27.5448 20.7277C28.3482 20.7277 28.9994 20.0765 28.9994 19.2732C28.9994 18.4699 28.3482 17.8187 27.5448 17.8187C26.7415 17.8187 26.0903 18.4699 26.0903 19.2732C26.0903 20.0765 26.7415 20.7277 27.5448 20.7277Z"
              fill="#18B7E9"
            />
            <path
              d="M18.8179 35.2729H36.272V38.1819H18.8179V35.2729ZM24.6359 27.7531L28.6969 31.817L34.4161 26.0935L36.272 28.0004V22.1823H30.454L32.3594 24.0368L28.6955 27.7007L24.6359 23.6368L18.8179 29.4549L20.8746 31.5115L24.6359 27.7531Z"
              fill="#18B7E9"
            />
            <path
              d="M37.7267 14.9097H32.9297C32.7869 14.6947 32.6315 14.4882 32.4643 14.2916L32.4498 14.2741C31.3811 13.0294 29.8775 12.2396 28.2462 12.0661C27.783 11.978 27.3073 11.978 26.8441 12.0661C25.2127 12.2396 23.7092 13.0294 22.6405 14.2741L22.626 14.2916C22.4588 14.4878 22.3034 14.6937 22.1605 14.9083L17.3635 14.9097C16.2066 14.9109 15.0974 15.371 14.2793 16.1891C13.4613 17.0071 13.0012 18.1163 13 19.2733V39.6365C13.0012 40.7934 13.4613 41.9026 14.2793 42.7207C15.0974 43.5387 16.2066 43.9988 17.3635 44H37.7267C38.8837 43.9988 39.9929 43.5387 40.8109 42.7207C41.629 41.9026 42.0891 40.7934 42.0903 39.6365V19.2733C42.0891 18.1163 41.629 17.0071 40.8109 16.1891C39.9929 15.371 38.8837 14.9109 37.7267 14.9097ZM39.1812 39.6365C39.1812 40.0222 39.028 40.3922 38.7552 40.665C38.4825 40.9377 38.1125 41.091 37.7267 41.091H17.3635C16.9779 41.0906 16.6082 40.9372 16.3355 40.6645C16.0628 40.3918 15.9094 40.0221 15.909 39.6365V19.2733C15.9094 18.8876 16.0628 18.5179 16.3355 18.2452C16.6082 17.9725 16.9779 17.8191 17.3635 17.8188H23.9816C24.1485 16.9967 24.5945 16.2577 25.2439 15.7269C25.8934 15.1961 26.7064 14.9061 27.5451 14.9061C28.3839 14.9061 29.1969 15.1961 29.8464 15.7269C30.4958 16.2577 30.9418 16.9967 31.1087 17.8188H37.7267C38.1124 17.8191 38.4821 17.9725 38.7548 18.2452C39.0275 18.5179 39.1809 18.8876 39.1812 19.2733V39.6365Z"
              fill="#18B7E9"
            />
          </svg>
        );

      case "outlined-info":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.2 4.5H8.8V6.1H7.2V4.5ZM7.2 7.7H8.8V12.5H7.2V7.7ZM8 0.5C3.584 0.5 0 4.084 0 8.5C0 12.916 3.584 16.5 8 16.5C12.416 16.5 16 12.916 16 8.5C16 4.084 12.416 0.5 8 0.5ZM8 14.9C4.472 14.9 1.6 12.028 1.6 8.5C1.6 4.972 4.472 2.1 8 2.1C11.528 2.1 14.4 4.972 14.4 8.5C14.4 12.028 11.528 14.9 8 14.9Z"
              fill="#E88A0F"
            />
          </svg>
        );

      case "industry_default":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            viewBox="0 0 32 32"
            fill={color}
          >
            <g clipPath="url(#clip0_251_1331)">
              <path
                d="M13.6274 14.904H9.27662C8.57259 14.904 8 14.3315 8 13.6274V9.27662C8 8.57259 8.57259 8 9.27662 8H13.6274C14.3315 8 14.904 8.57259 14.904 9.27662V13.6274C14.904 14.3315 14.3315 14.904 13.6274 14.904ZM9.49001 13.414H13.414V9.49001H9.49001V13.414Z"
                fill="#0B93DF"
              />
              <path
                d="M22.5312 14.904H18.1804C17.4764 14.904 16.9038 14.3315 16.9038 13.6274V9.27662C16.9038 8.57259 17.4764 8 18.1804 8H22.5312C23.2353 8 23.8079 8.57259 23.8079 9.27662V13.6274C23.8079 14.3315 23.2353 14.904 22.5312 14.904ZM18.3938 13.414H22.3179V9.49001H18.3938V13.414Z"
                fill="#0B93DF"
              />
              <path
                d="M13.6274 23.8081H9.27662C8.57259 23.8081 8 23.2355 8 22.5315V18.1807C8 17.4766 8.57259 16.9041 9.27662 16.9041H13.6274C14.3315 16.9041 14.904 17.4766 14.904 18.1807V22.5315C14.904 23.2355 14.3315 23.8081 13.6274 23.8081ZM9.49001 22.3181H13.414V18.3941H9.49001V22.3181Z"
                fill="#0B93DF"
              />
              <path
                d="M20.1824 23.4611C18.3747 23.4611 16.9038 21.9903 16.9038 20.1826C16.9038 18.3749 18.3747 16.9041 20.1824 16.9041C21.99 16.9041 23.4609 18.3749 23.4609 20.1826C23.4609 21.9903 21.99 23.4611 20.1824 23.4611ZM20.1824 18.3946C19.1963 18.3946 18.3938 19.1971 18.3938 20.1831C18.3938 21.1692 19.1963 21.9717 20.1824 21.9717C21.1684 21.9717 21.9709 21.1692 21.9709 20.1831C21.9709 19.1971 21.1684 18.3946 20.1824 18.3946Z"
                fill="#0B93DF"
              />
              <path
                d="M23.1629 23.8832C22.9665 23.8832 22.7701 23.8061 22.6238 23.6523L21.5244 22.4997C21.2402 22.2016 21.2514 21.7302 21.5494 21.4465C21.8474 21.1629 22.3189 21.1735 22.6025 21.4715L23.7019 22.6242C23.9861 22.9222 23.9749 23.3937 23.6769 23.6773C23.5327 23.8146 23.3475 23.8832 23.1629 23.8832Z"
                fill="#0B93DF"
              />
            </g>
            <defs>
              <clipPath id="clip0_251_1331">
                <rect width="15.958" height="16" fill="white" transform="translate(8 8)" />
              </clipPath>
            </defs>
          </svg>
        );

      case "graph":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            viewBox="0 0 22 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.8752 2C15.5878 2 15.3123 1.89464 15.1091 1.70711C14.906 1.51957 14.7918 1.26522 14.7918 1C14.7918 0.734783 14.906 0.48043 15.1091 0.292893C15.3123 0.105357 15.5878 0 15.8752 0H20.2085C20.4958 0 20.7714 0.105357 20.9745 0.292893C21.1777 0.48043 21.2918 0.734783 21.2918 1V5C21.2918 5.26522 21.1777 5.51957 20.9745 5.70711C20.7714 5.89464 20.4958 6 20.2085 6C19.9212 6 19.6456 5.89464 19.4425 5.70711C19.2393 5.51957 19.1252 5.26522 19.1252 5V3.414L12.8494 9.207C12.6463 9.39447 12.3708 9.49979 12.0835 9.49979C11.7962 9.49979 11.5207 9.39447 11.3176 9.207L8.29183 6.414L2.55775 11.707C2.35343 11.8892 2.07977 11.99 1.79573 11.9877C1.51168 11.9854 1.23997 11.8802 1.03911 11.6948C0.838251 11.5094 0.724318 11.2586 0.721849 10.9964C0.719381 10.7342 0.828575 10.4816 1.02591 10.293L7.52591 4.293C7.72907 4.10553 8.00457 4.00021 8.29183 4.00021C8.57909 4.00021 8.85459 4.10553 9.05775 4.293L12.0835 7.086L17.5933 2H15.8752ZM2.87516 16V19C2.87516 19.2652 2.76103 19.5196 2.55786 19.7071C2.3547 19.8946 2.07915 20 1.79183 20C1.50451 20 1.22896 19.8946 1.0258 19.7071C0.822633 19.5196 0.708496 19.2652 0.708496 19V16C0.708496 15.7348 0.822633 15.4804 1.0258 15.2929C1.22896 15.1054 1.50451 15 1.79183 15C2.07915 15 2.3547 15.1054 2.55786 15.2929C2.76103 15.4804 2.87516 15.7348 2.87516 16ZM8.29183 12C8.29183 11.7348 8.17769 11.4804 7.97453 11.2929C7.77136 11.1054 7.49581 11 7.2085 11C6.92118 11 6.64563 11.1054 6.44246 11.2929C6.2393 11.4804 6.12516 11.7348 6.12516 12V19C6.12516 19.2652 6.2393 19.5196 6.44246 19.7071C6.64563 19.8946 6.92118 20 7.2085 20C7.49581 20 7.77136 19.8946 7.97453 19.7071C8.17769 19.5196 8.29183 19.2652 8.29183 19V12ZM12.6252 13C12.9125 13 13.188 13.1054 13.3912 13.2929C13.5944 13.4804 13.7085 13.7348 13.7085 14V19C13.7085 19.2652 13.5944 19.5196 13.3912 19.7071C13.188 19.8946 12.9125 20 12.6252 20C12.3378 20 12.0623 19.8946 11.8591 19.7071C11.656 19.5196 11.5418 19.2652 11.5418 19V14C11.5418 13.7348 11.656 13.4804 11.8591 13.2929C12.0623 13.1054 12.3378 13 12.6252 13ZM19.1252 9C19.1252 8.73478 19.011 8.48043 18.8079 8.29289C18.6047 8.10536 18.3291 8 18.0418 8C17.7545 8 17.479 8.10536 17.2758 8.29289C17.0726 8.48043 16.9585 8.73478 16.9585 9V19C16.9585 19.2652 17.0726 19.5196 17.2758 19.7071C17.479 19.8946 17.7545 20 18.0418 20C18.3291 20 18.6047 19.8946 18.8079 19.7071C19.011 19.5196 19.1252 19.2652 19.1252 19V9Z"
              fill="#0B93DF"
            />
          </svg>
        );

      case "bulls-eye":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.99951 0C10.3745 0 10.7445 0.0200001 11.1095 0.0610001C11.24 0.0754455 11.3665 0.11546 11.4815 0.178759C11.5966 0.242058 11.6981 0.327402 11.7802 0.429918C11.8622 0.532433 11.9233 0.650114 11.9599 0.776239C11.9966 0.902365 12.008 1.03447 11.9935 1.165C11.9791 1.29553 11.9391 1.42194 11.8758 1.53701C11.8125 1.65208 11.7271 1.75356 11.6246 1.83565C11.5221 1.91773 11.4044 1.97882 11.2783 2.01543C11.1521 2.05204 11.02 2.06345 10.8895 2.049C9.24156 1.86464 7.57704 2.19694 6.12619 2.99992C4.67534 3.80291 3.50987 5.03689 2.79098 6.5312C2.07209 8.0255 1.83531 9.70627 2.1134 11.341C2.39149 12.9758 3.1707 14.4837 4.34325 15.6563C5.5158 16.8288 7.02374 17.608 8.65849 17.8861C10.2932 18.1642 11.974 17.9274 13.4683 17.2085C14.9626 16.4896 16.1966 15.3242 16.9996 13.8733C17.8026 12.4225 18.1349 10.758 17.9505 9.11C17.9361 8.97947 17.9475 8.84736 17.9841 8.72124C18.0207 8.59511 18.0818 8.47743 18.1639 8.37492C18.3296 8.16788 18.5709 8.03517 18.8345 8.006C19.0981 7.97683 19.3626 8.05357 19.5696 8.21935C19.6721 8.30144 19.7575 8.40292 19.8208 8.51799C19.8841 8.63306 19.9241 8.75947 19.9385 8.89C19.9785 9.255 19.9995 9.625 19.9995 10C19.9995 15.523 15.5225 20 9.99951 20C4.47651 20 -0.000488281 15.523 -0.000488281 10C-0.000488281 4.477 4.47651 0 9.99951 0ZM9.96751 5.877C10.0334 6.13372 9.99471 6.40611 9.85989 6.63431C9.72507 6.8625 9.50517 7.02785 9.24851 7.094C8.54338 7.27871 7.92955 7.71367 7.52155 8.31771C7.11355 8.92175 6.93926 9.6536 7.03121 10.3767C7.12316 11.0998 7.47506 11.7647 8.02125 12.2474C8.56744 12.7301 9.27059 12.9976 9.99951 13C10.6646 12.9997 11.3107 12.7786 11.8365 12.3714C12.3622 11.9641 12.7379 11.3938 12.9045 10.75C12.9708 10.4931 13.1364 10.2731 13.365 10.1384C13.5935 10.0036 13.8661 9.9652 14.123 10.0315C14.3799 10.0978 14.5999 10.2634 14.7346 10.4919C14.8694 10.7205 14.9078 10.9931 14.8415 11.25C14.5347 12.4259 13.8104 13.45 12.8037 14.1308C11.797 14.8116 10.5769 15.1026 9.37127 14.9495C8.16567 14.7964 7.05705 14.2096 6.25252 13.2987C5.44799 12.3879 5.00258 11.2153 4.99951 10C4.99968 8.89148 5.36809 7.81441 6.04685 6.938C6.72561 6.06158 7.67627 5.43546 8.74951 5.158C8.8767 5.12522 9.0091 5.11781 9.13914 5.13621C9.26919 5.1546 9.39434 5.19843 9.50745 5.2652C9.62055 5.33197 9.7194 5.42036 9.79834 5.52534C9.87727 5.63031 9.93476 5.74981 9.96751 5.877ZM16.5035 0.127C16.686 0.202679 16.8421 0.330737 16.9519 0.495009C17.0617 0.659282 17.1204 0.852404 17.1205 1.05V2.88H18.9495C19.1473 2.88004 19.3406 2.93871 19.505 3.0486C19.6694 3.15848 19.7975 3.31465 19.8732 3.49735C19.9489 3.68005 19.9687 3.88108 19.9301 4.07503C19.8915 4.26898 19.7963 4.44715 19.6565 4.587L16.1195 8.12C15.932 8.30755 15.6777 8.41294 15.4125 8.413H12.9995L11.1715 10.242C10.9839 10.4296 10.7294 10.5351 10.464 10.5351C10.1986 10.5351 9.94415 10.4296 9.75651 10.242C9.56887 10.0544 9.46346 9.79986 9.46346 9.5345C9.46346 9.26914 9.56887 9.01464 9.75651 8.827L11.5855 7V4.586C11.5856 4.32081 11.691 4.06649 11.8785 3.879L15.4135 0.343C15.5534 0.203067 15.7316 0.107758 15.9256 0.0691314C16.1196 0.0305044 16.3207 0.0502951 16.5035 0.126V0.127ZM15.1205 3.464L13.5855 5V6.414H14.9995L16.5355 4.879H16.1205C15.8553 4.879 15.6009 4.77364 15.4134 4.58611C15.2259 4.39857 15.1205 4.14422 15.1205 3.879V3.464Z"
              fill="#0B93DF"
            />
          </svg>
        );

      case "no-data-found":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            viewBox="0 0 133 90"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_488_703)">
              <path
                d="M0.543567 27.9986L-0.000976562 28.0381L0.724283 38.1749L1.26883 38.1354L0.543567 27.9986Z"
                fill="#AFAFAF"
              />
              <path
                d="M1.64415 43.3687L1.09961 43.4082L1.37261 47.2239L1.91716 47.1844L1.64415 43.3687Z"
                fill="#AFAFAF"
              />
              <path
                d="M128.076 90H11.154C8.51155 90 6.19125 87.8234 6.00016 85.1576L0.256719 4.84243C0.0656344 2.17662 2.07475 0 4.71717 0H121.639C124.281 0 126.602 2.17662 126.793 4.84243L132.536 85.1631C132.727 87.8234 130.718 90.0055 128.076 90.0055V90Z"
                fill="#AFAFAF"
              />
              <path
                d="M128.523 90H11.6012C8.95882 90 6.63851 87.8234 6.44743 85.1576L0.703984 4.84243C0.5129 2.17662 2.52201 0 5.16443 0H122.086C124.728 0 127.049 2.17662 127.24 4.84243L132.983 85.1631C133.174 87.8234 131.165 90.0055 128.523 90.0055V90Z"
                fill="#AFAFAF"
              />
              <path
                opacity="0.5"
                d="M128.523 90H11.6012C8.95882 90 6.63851 87.8234 6.44743 85.1576L0.703984 4.84243C0.5129 2.17662 2.52201 0 5.16443 0H122.086C124.728 0 127.049 2.17662 127.24 4.84243L132.983 85.1631C133.174 87.8234 131.165 90.0055 128.523 90.0055V90Z"
                fill="white"
              />
              <path
                d="M122.261 2.41895H5.33905C5.20802 2.41895 5.07699 2.41895 4.94596 2.43543C1.95959 2.68278 2.5656 7.26138 5.58473 7.26138H122.703C125.722 7.26138 125.673 2.68278 122.648 2.43543C122.517 2.42444 122.386 2.41895 122.255 2.41895H122.261Z"
                fill="#AFAFAF"
              />
              <path
                d="M8.38569 4.84272C8.42937 5.45833 7.97077 5.95302 7.36476 5.95302C6.75875 5.95302 6.22917 5.45833 6.1855 4.84272C6.14182 4.23261 6.60042 3.73242 7.20643 3.73242C7.81244 3.73242 8.34202 4.22711 8.38569 4.84272Z"
                fill="#FAFAFA"
              />
              <path
                d="M12.1367 4.84272C12.1803 5.45833 11.7217 5.95302 11.1157 5.95302C10.5097 5.95302 9.98015 5.45833 9.93647 4.84272C9.8928 4.23261 10.3514 3.73242 10.9574 3.73242C11.5634 3.73242 12.093 4.22711 12.1367 4.84272Z"
                fill="#FAFAFA"
              />
              <path
                d="M15.8818 4.84272C15.9255 5.45833 15.4669 5.95302 14.8609 5.95302C14.2548 5.95302 13.7253 5.45833 13.6816 4.84272C13.6379 4.23261 14.0965 3.73242 14.7025 3.73242C15.3085 3.73242 15.8381 4.22711 15.8818 4.84272Z"
                fill="#FAFAFA"
              />
              <path
                d="M125.422 81.9858H13.5554C12.5945 81.9858 11.7538 81.1998 11.6882 80.2324L6.96573 14.1753C6.89475 13.2079 7.62087 12.4219 8.58175 12.4219H120.448C121.409 12.4219 122.25 13.2079 122.315 14.1753L127.038 80.2269C127.109 81.1943 126.382 81.9803 125.422 81.9803V81.9858Z"
                fill="white"
              />
              <path d="M78.296 56.8232L76.4725 31.3634L70.9584 28.0215H55.7754L57.8391 56.8232H78.296Z" fill="white" />
              <path
                d="M78.2958 57.0869H57.8389C57.7024 57.0869 57.5823 56.9769 57.5768 56.8395L55.5186 28.0378C55.5186 27.9663 55.5404 27.8894 55.5895 27.8344C55.6387 27.7794 55.7096 27.752 55.7806 27.752H70.9581C71.0073 27.752 71.051 27.7629 71.0946 27.7904L76.6142 31.1323C76.6907 31.1763 76.7343 31.2532 76.7398 31.3412L78.5633 56.8011C78.5633 56.8725 78.5415 56.9495 78.4923 57.0044C78.4432 57.0594 78.3722 57.0869 78.3012 57.0869H78.2958ZM58.0845 56.5537H78.0119L76.2212 31.5171L70.8817 28.2851H56.059L58.0791 56.5537H58.0845Z"
                fill="#AFAFAF"
              />
              <path d="M76.4722 31.3624L70.958 28.0205L72.9835 32.4507L76.4722 31.3624Z" fill="#EBEBEB" />
              <path
                d="M72.9833 32.715C72.8851 32.715 72.7868 32.6546 72.7431 32.5611L70.7176 28.1309C70.6685 28.0265 70.6958 27.9001 70.7831 27.8231C70.8705 27.7462 70.9961 27.7352 71.0943 27.7956L76.6139 31.1375C76.7013 31.1925 76.7504 31.2914 76.7395 31.3959C76.7286 31.5003 76.6522 31.5882 76.5539 31.6157L73.0598 32.704C73.0598 32.704 73.0052 32.715 72.9833 32.715ZM71.5584 28.6916L73.1307 32.1214L75.8387 31.2804L71.5639 28.6916H71.5584Z"
                fill="#AFAFAF"
              />
              <path
                d="M64.3405 40.9983C64.3841 41.6414 63.9037 42.1635 63.2704 42.1635C62.6371 42.1635 62.0748 41.6414 62.0311 40.9983C61.9874 40.3552 62.4678 39.833 63.1011 39.833C63.7345 39.833 64.2968 40.3552 64.3405 40.9983Z"
                fill="#AFAFAF"
              />
              <path
                d="M71.8424 40.9983C71.8861 41.6414 71.4057 42.1635 70.7723 42.1635C70.139 42.1635 69.5767 41.6414 69.533 40.9983C69.4894 40.3552 69.9698 39.833 70.6031 39.833C71.2364 39.833 71.7987 40.3552 71.8424 40.9983Z"
                fill="#AFAFAF"
              />
              <path
                d="M73.9551 48.5449C73.8187 48.5449 73.704 48.4405 73.6931 48.2976C73.5566 46.4287 70.6467 44.9062 67.1962 44.9062C64.9141 44.9062 62.8613 45.5878 61.8404 46.6926C61.3873 47.1818 61.1798 47.7094 61.218 48.2646C61.2289 48.413 61.1197 48.5394 60.9723 48.5504C60.8249 48.5614 60.6994 48.4515 60.6884 48.3031C60.6393 47.605 60.9014 46.9234 61.4528 46.3298C62.5665 45.1261 64.7667 44.373 67.1962 44.373C70.9797 44.373 74.0643 46.0825 74.2227 48.2591C74.2336 48.4075 74.1244 48.5339 73.977 48.5449C73.9715 48.5449 73.9661 48.5449 73.9551 48.5449Z"
                fill="#AFAFAF"
              />
              <path
                d="M60.0828 38.6403C60.0173 38.6403 59.9517 38.6183 59.9026 38.5689C59.7934 38.4699 59.788 38.2995 59.8862 38.1951L61.0437 36.9364C61.1419 36.8265 61.3112 36.821 61.4149 36.9199C61.5241 37.0188 61.5296 37.1892 61.4313 37.2937L60.2739 38.5524C60.2193 38.6073 60.1483 38.6403 60.0773 38.6403H60.0828Z"
                fill="#AFAFAF"
              />
              <path
                d="M73.4098 38.6405C73.3443 38.6405 73.2788 38.6185 73.2297 38.5691L71.8921 37.3104C71.7829 37.2114 71.7774 37.041 71.8811 36.9366C71.9794 36.8267 72.1487 36.8212 72.2524 36.9256L73.59 38.1843C73.6992 38.2832 73.7046 38.4536 73.6009 38.5581C73.5463 38.613 73.4808 38.6405 73.4098 38.6405Z"
                fill="#AFAFAF"
              />
              <path
                d="M54.126 62.5117H55.3598L57.1396 64.8917L56.9704 62.5117H58.2152L58.5209 66.8155H57.2761L55.5072 64.452L55.6765 66.8155H54.4317L54.126 62.5117Z"
                fill="#AFAFAF"
              />
              <path
                d="M59.0773 64.672C59.0282 63.9685 59.181 63.4243 59.5414 63.0286C59.9017 62.6328 60.4313 62.4404 61.1246 62.4404C61.818 62.4404 62.3967 62.6328 62.8116 63.0176C63.2266 63.4023 63.4559 63.941 63.505 64.6335C63.5432 65.1392 63.4886 65.5515 63.3412 65.8703C63.1938 66.1946 62.97 66.4419 62.6642 66.6233C62.3585 66.8047 61.9709 66.8926 61.4959 66.8926C61.0209 66.8926 60.6114 66.8157 60.2839 66.6618C59.9563 66.5079 59.6833 66.2605 59.4649 65.9252C59.2466 65.5899 59.1155 65.1722 59.0828 64.6665L59.0773 64.672ZM60.3985 64.6775C60.4313 65.1117 60.5296 65.425 60.7043 65.6119C60.879 65.8043 61.1028 65.8977 61.3812 65.8977C61.6597 65.8977 61.8781 65.8043 62.02 65.6174C62.162 65.4305 62.2166 65.0952 62.1838 64.6171C62.1565 64.2103 62.0528 63.9135 61.8781 63.7266C61.7034 63.5397 61.4741 63.4463 61.1956 63.4463C60.9172 63.4463 60.7206 63.5397 60.5732 63.7321C60.4258 63.9245 60.3658 64.2378 60.3985 64.6775Z"
                fill="#AFAFAF"
              />
              <path
                d="M66.0767 62.5117H68.0422C68.4298 62.5117 68.7465 62.5667 68.9921 62.6711C69.2378 62.7755 69.4453 62.9295 69.6145 63.1273C69.7838 63.3252 69.9148 63.5561 70.0022 63.8199C70.0895 64.0837 70.1441 64.3585 70.166 64.6554C70.1987 65.1171 70.1714 65.4743 70.0841 65.7272C69.9967 65.98 69.8711 66.1944 69.6964 66.3648C69.5217 66.5352 69.3361 66.6506 69.1232 66.7056C68.8393 66.7825 68.5772 66.821 68.3425 66.821H66.377L66.0713 62.5172L66.0767 62.5117ZM67.4689 63.4846L67.6382 65.8371H67.9603C68.2387 65.8371 68.4298 65.8041 68.5445 65.7437C68.6591 65.6832 68.741 65.5733 68.7956 65.4194C68.8502 65.2655 68.8666 65.0181 68.8393 64.6719C68.8065 64.2156 68.7083 63.9023 68.5499 63.7374C68.3916 63.567 68.1405 63.4846 67.7965 63.4846H67.4689Z"
                fill="#AFAFAF"
              />
              <path
                d="M73.3383 66.1064H71.8369L71.6786 66.8155H70.3301L71.6294 62.5117H73.0708L74.9871 66.8155H73.6058L73.3437 66.1064H73.3383ZM72.9998 65.1775L72.4156 63.6275L72.0608 65.1775H72.9998Z"
                fill="#AFAFAF"
              />
              <path
                d="M74.3867 62.5117H78.4049L78.4814 63.5725H77.1329L77.3622 66.8155H76.041L75.8117 63.5725H74.4632L74.3867 62.5117Z"
                fill="#AFAFAF"
              />
              <path
                d="M81.4838 66.1064H79.9824L79.8241 66.8155H78.4756L79.775 62.5117H81.2163L83.1326 66.8155H81.7513L81.4892 66.1064H81.4838ZM81.1453 65.1775L80.5611 63.6275L80.2063 65.1775H81.1453Z"
                fill="#AFAFAF"
              />
            </g>
            <defs>
              <clipPath id="clip0_488_703">
                <rect width="133" height="90" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );

      case "logout":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M12.4444 4.44444L11.1911 5.69778L12.5956 7.11111H5.33333V8.88889H12.5956L11.1911 10.2933L12.4444 11.5556L16 8L12.4444 4.44444ZM1.77778 1.77778H8V0H1.77778C0.8 0 0 0.8 0 1.77778V14.2222C0 15.2 0.8 16 1.77778 16H8V14.2222H1.77778V1.77778Z" />
          </svg>
        );
      case "close":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            viewBox="0 0 14 14"
            onClick={onClick}
            style={style}
            className={className}
            fill={color}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L13 13M1 13L13 1"
              stroke={color || "#AFAFAF"}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case "location":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            fill={color}
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.6663 6.00065C12.6663 5.38782 12.5456 4.78098 12.3111 4.2148C12.0766 3.64861 11.7328 3.13416 11.2995 2.70082C10.8662 2.26748 10.3517 1.92374 9.78553 1.68921C9.21934 1.45469 8.61251 1.33398 7.99967 1.33398C7.38684 1.33398 6.78 1.45469 6.21382 1.68921C5.64763 1.92374 5.13318 2.26748 4.69984 2.70082C4.2665 3.13416 3.92276 3.64861 3.68824 4.2148C3.45371 4.78098 3.33301 5.38782 3.33301 6.00065C3.33301 6.92532 3.60567 7.78532 4.06967 8.51065H4.06434L7.99967 14.6673L11.935 8.51065H11.9303C12.4109 7.76171 12.6664 6.89053 12.6663 6.00065ZM7.99967 8.00065C7.46924 8.00065 6.96053 7.78994 6.58546 7.41487C6.21039 7.03979 5.99967 6.53108 5.99967 6.00065C5.99967 5.47022 6.21039 4.96151 6.58546 4.58644C6.96053 4.21136 7.46924 4.00065 7.99967 4.00065C8.53011 4.00065 9.03882 4.21136 9.41389 4.58644C9.78896 4.96151 9.99967 5.47022 9.99967 6.00065C9.99967 6.53108 9.78896 7.03979 9.41389 7.41487C9.03882 7.78994 8.53011 8.00065 7.99967 8.00065Z"
              fill="#555555;
"
            />
          </svg>
        );
      case "team":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            fill={color}
            viewBox="0 0 14 13"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 0.502014C6.73762 0.502014 6.47781 0.553694 6.2354 0.654103C5.99299 0.754512 5.77273 0.901683 5.5872 1.08721C5.40167 1.27275 5.2545 1.493 5.15409 1.73541C5.05368 1.97782 5.002 2.23763 5.002 2.50001C5.002 2.7624 5.05368 3.02221 5.15409 3.26462C5.2545 3.50702 5.40167 3.72728 5.5872 3.91281C5.77273 4.09834 5.99299 4.24552 6.2354 4.34593C6.47781 4.44633 6.73762 4.49801 7 4.49801C7.5299 4.49801 8.0381 4.28751 8.4128 3.91281C8.7875 3.53812 8.998 3.02992 8.998 2.50001C8.998 1.97011 8.7875 1.46191 8.4128 1.08721C8.0381 0.712517 7.5299 0.502014 7 0.502014ZM11.5 1.50001C11.1022 1.50001 10.7206 1.65805 10.4393 1.93935C10.158 2.22066 10 2.60219 10 3.00001C10 3.39784 10.158 3.77937 10.4393 4.06067C10.7206 4.34198 11.1022 4.50001 11.5 4.50001C11.8978 4.50001 12.2794 4.34198 12.5607 4.06067C12.842 3.77937 13 3.39784 13 3.00001C13 2.60219 12.842 2.22066 12.5607 1.93935C12.2794 1.65805 11.8978 1.50001 11.5 1.50001ZM2.5 1.50001C2.10218 1.50001 1.72064 1.65805 1.43934 1.93935C1.15804 2.22066 1 2.60219 1 3.00001C1 3.39784 1.15804 3.77937 1.43934 4.06067C1.72064 4.34198 2.10218 4.50001 2.5 4.50001C2.89783 4.50001 3.27936 4.34198 3.56066 4.06067C3.84197 3.77937 4 3.39784 4 3.00001C4 2.60219 3.84197 2.22066 3.56066 1.93935C3.27936 1.65805 2.89783 1.50001 2.5 1.50001ZM4 6.49301C4.00185 6.22901 4.10802 5.97645 4.29536 5.79043C4.48269 5.6044 4.73599 5.50001 5 5.50001H9C9.26522 5.50001 9.51957 5.60537 9.70711 5.79291C9.89464 5.98044 10 6.2348 10 6.50001V9.50001C9.99993 9.81473 9.95067 10.1275 9.854 10.427C9.63257 11.1057 9.17644 11.6833 8.56751 12.0559C7.95859 12.4286 7.23675 12.5719 6.53163 12.4603C5.8265 12.3486 5.18428 11.9893 4.72028 11.4467C4.25628 10.9041 4.0009 10.2139 4 9.50001V6.49301ZM3 6.50001C3 6.13501 3.097 5.79401 3.268 5.50001H1C0.734784 5.50001 0.48043 5.60537 0.292893 5.79291C0.105357 5.98044 1.38413e-07 6.2348 1.38413e-07 6.50001V9.00001C-0.000136048 9.40932 0.100226 9.8124 0.292273 10.1739C0.48432 10.5353 0.762177 10.8441 1.10144 11.0731C1.44071 11.302 1.831 11.4442 2.23806 11.4871C2.64511 11.53 3.05646 11.4723 3.436 11.319C3.14818 10.7556 2.99872 10.1317 3 9.49901V6.50001ZM11 6.50001V9.50001C11 10.155 10.843 10.773 10.564 11.319C10.9435 11.4723 11.3549 11.53 11.7619 11.4871C12.169 11.4442 12.5593 11.302 12.8986 11.0731C13.2378 10.8441 13.5157 10.5353 13.7077 10.1739C13.8998 9.8124 14.0001 9.40932 14 9.00001V6.50001C14 6.2348 13.8946 5.98044 13.7071 5.79291C13.5196 5.60537 13.2652 5.50001 13 5.50001H10.732C10.902 5.79401 11 6.13501 11 6.50001Z"
              fill="#555555"
            />
          </svg>
        );
      case "caret-up":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            fill={color}
            viewBox="0 0 14 8"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.364 7.70699C13.1764 7.89446 12.9221 7.99977 12.657 7.99977C12.3918 7.99977 12.1375 7.89446 11.95 7.70699L6.99995 2.75699L2.04995 7.70699C1.86135 7.88914 1.60875 7.98994 1.34655 7.98766C1.08435 7.98538 0.83354 7.88021 0.648132 7.69481C0.462725 7.5094 0.357556 7.25858 0.355278 6.99639C0.353 6.73419 0.453794 6.48159 0.635952 6.29299L6.29295 0.635987C6.48048 0.448516 6.73479 0.343201 6.99995 0.343201C7.26512 0.343201 7.51942 0.448516 7.70695 0.635987L13.364 6.29299C13.5514 6.48052 13.6567 6.73482 13.6567 6.99999C13.6567 7.26515 13.5514 7.51946 13.364 7.70699Z"
              fill="black"
            />
          </svg>
        );
      case "caret-down":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            fill={color}
            viewBox="0 0 14 8"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.364 0.293013C13.1764 0.105542 12.9221 0.000226498 12.657 0.000226498C12.3918 0.000226498 12.1375 0.105542 11.95 0.293013L6.99995 5.24301L2.04995 0.293013C1.86135 0.110855 1.60875 0.0100608 1.34655 0.0123391C1.08435 0.0146174 0.83354 0.119786 0.648132 0.305194C0.462725 0.490602 0.357556 0.741415 0.355278 1.00361C0.353 1.26581 0.453794 1.51841 0.635952 1.70701L6.29295 7.36401C6.48048 7.55148 6.73479 7.6568 6.99995 7.6568C7.26512 7.6568 7.51942 7.55148 7.70695 7.36401L13.364 1.70701C13.5514 1.51948 13.6567 1.26518 13.6567 1.00001C13.6567 0.734848 13.5514 0.480541 13.364 0.293013Z"
              fill="black"
            />
          </svg>
        );
      case "case-study":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            fill={color}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="currentColor" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.18266 6.25962C6.46143 6.98024 6.46143 8.14085 6.46143 10.4615V12.923C6.46143 15.2436 6.46143 16.4042 7.18266 17.1249C7.90327 17.8461 9.06389 17.8461 11.3845 17.8461H12.6153C14.9359 17.8461 16.0965 17.8461 16.8171 17.1249C17.5383 16.4042 17.5383 15.2436 17.5383 12.923V10.4615C17.5383 8.14085 17.5383 6.98024 16.8171 6.25962C16.0965 5.53839 14.9359 5.53839 12.6153 5.53839H11.3845C9.06389 5.53839 7.90327 5.53839 7.18266 6.25962ZM9.53835 9.99993C9.41594 9.99993 9.29855 10.0486 9.21199 10.1351C9.12544 10.2217 9.07681 10.3391 9.07681 10.4615C9.07681 10.5839 9.12544 10.7013 9.21199 10.7878C9.29855 10.8744 9.41594 10.923 9.53835 10.923H14.4614C14.5838 10.923 14.7012 10.8744 14.7878 10.7878C14.8743 10.7013 14.923 10.5839 14.923 10.4615C14.923 10.3391 14.8743 10.2217 14.7878 10.1351C14.7012 10.0486 14.5838 9.99993 14.4614 9.99993H9.53835ZM9.53835 12.4615C9.41594 12.4615 9.29855 12.5101 9.21199 12.5967C9.12544 12.6832 9.07681 12.8006 9.07681 12.923C9.07681 13.0454 9.12544 13.1628 9.21199 13.2494C9.29855 13.3359 9.41594 13.3845 9.53835 13.3845H12.6153C12.7377 13.3845 12.8551 13.3359 12.9416 13.2494C13.0282 13.1628 13.0768 13.0454 13.0768 12.923C13.0768 12.8006 13.0282 12.6832 12.9416 12.5967C12.8551 12.5101 12.7377 12.4615 12.6153 12.4615H9.53835Z"
              fill="#F5F5F5"
            />
          </svg>
        );
      case "clutch-review":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            fill={color}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="currentColor" />
            <path
              d="M11.8041 9.24266V13.5662L13.5629 14.9219L12.9034 12.6868L14.5522 11.5144H12.5003L11.8041 9.24266ZM11.8041 15.3982L9.09277 17.4684C8.95842 17.5783 8.81186 17.6303 8.65309 17.6245C8.49431 17.6186 8.35386 17.5727 8.23172 17.4867C8.10959 17.4012 8.01506 17.2852 7.94813 17.1386C7.8812 16.9921 7.87802 16.8333 7.9386 16.6623L8.98285 13.2731L6.32643 11.3861C6.17987 11.2884 6.08827 11.1602 6.05163 11.0014C6.01499 10.8426 6.0211 10.6961 6.06995 10.5617C6.1188 10.4274 6.2043 10.3082 6.32643 10.2041C6.44857 10.1 6.59513 10.0483 6.76611 10.0487H10.0454L11.108 6.53129C11.169 6.3603 11.2638 6.22888 11.3923 6.13704C11.5208 6.04519 11.6581 5.99952 11.8041 6C11.9507 6 12.0882 6.04593 12.2167 6.13777C12.3452 6.22962 12.4397 6.36079 12.5003 6.53129L13.5629 10.0487H16.8422C17.0132 10.0487 17.1597 10.1008 17.2819 10.2048C17.404 10.3089 17.4895 10.4279 17.5383 10.5617C17.5872 10.6961 17.5933 10.8426 17.5567 11.0014C17.52 11.1602 17.4284 11.2884 17.2819 11.3861L14.6254 13.2731L15.6697 16.6623C15.7308 16.8333 15.7278 16.9921 15.6609 17.1386C15.594 17.2852 15.4992 17.4012 15.3766 17.4867C15.2544 17.5722 15.114 17.6181 14.9552 17.6245C14.7964 17.6308 14.6499 17.5788 14.5155 17.4684L11.8041 15.3982Z"
              fill="white"
            />{" "}
          </svg>
        );
      case "testimony":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            fill={color}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12.2412" cy="12" r="12" fill="currentColor" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.40788 6.75C7.09846 6.75 6.80171 6.87292 6.58292 7.09171C6.36413 7.3105 6.24121 7.60725 6.24121 7.91667V16.0833C6.24121 16.3928 6.36413 16.6895 6.58292 16.9083C6.80171 17.1271 7.09846 17.25 7.40788 17.25H16.7412C17.0506 17.25 17.3474 17.1271 17.5662 16.9083C17.785 16.6895 17.9079 16.3928 17.9079 16.0833V7.91667C17.9079 7.60725 17.785 7.3105 17.5662 7.09171C17.3474 6.87292 17.0506 6.75 16.7412 6.75H7.40788ZM10.1058 10.0342C10.1187 9.92264 10.1576 9.81569 10.2192 9.72184C10.2808 9.62799 10.3635 9.54984 10.4607 9.49362C10.5579 9.43741 10.6669 9.40469 10.7789 9.39807C10.891 9.39145 11.0031 9.41112 11.1062 9.4555C11.4002 9.5815 12.0209 9.865 12.8072 10.3188C13.3596 10.635 13.8933 10.9829 14.4055 11.3607C14.4956 11.4277 14.5687 11.5148 14.6191 11.615C14.6694 11.7153 14.6957 11.826 14.6957 11.9382C14.6957 12.0504 14.6694 12.161 14.6191 12.2613C14.5687 12.3616 14.4956 12.4487 14.4055 12.5157C13.8933 12.8931 13.3596 13.2405 12.8072 13.5563C12.2573 13.877 11.6894 14.1657 11.1062 14.4208C11.0031 14.4653 10.891 14.4851 10.7789 14.4786C10.6668 14.472 10.5577 14.4393 10.4605 14.3831C10.3633 14.3268 10.2806 14.2486 10.219 14.1547C10.1574 14.0608 10.1186 13.9537 10.1058 13.8422C10.0353 13.21 10.001 12.5743 10.0031 11.9382C10.0031 11.0334 10.0685 10.3521 10.1058 10.0342Z"
              fill="white"
            />
          </svg>
        );
      case "arrow-new-tab":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            fill={color}
            viewBox="0 0 18 18"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.272 4.25C8.272 4.05109 8.35102 3.86032 8.49167 3.71967C8.63232 3.57902 8.82309 3.5 9.022 3.5H13.75C13.9489 3.5 14.1397 3.57902 14.2803 3.71967C14.421 3.86032 14.5 4.05109 14.5 4.25V8.979C14.5 9.17791 14.421 9.36868 14.2803 9.50933C14.1397 9.64998 13.9489 9.729 13.75 9.729C13.5511 9.729 13.3603 9.64998 13.2197 9.50933C13.079 9.36868 13 9.17791 13 8.979V6.06L7.78 11.28C7.71078 11.3516 7.628 11.4087 7.53647 11.448C7.44495 11.4872 7.34653 11.5079 7.24694 11.5087C7.14736 11.5095 7.04861 11.4905 6.95646 11.4527C6.8643 11.415 6.78059 11.3592 6.7102 11.2888C6.63982 11.2183 6.58417 11.1346 6.5465 11.0424C6.50883 10.9502 6.4899 10.8514 6.49081 10.7518C6.49173 10.6523 6.51246 10.5539 6.55181 10.4624C6.59116 10.3709 6.64834 10.2882 6.72 10.219L11.94 5H9.022C8.82309 5 8.63232 4.92098 8.49167 4.78033C8.35102 4.63968 8.272 4.44891 8.272 4.25ZM3.157 2.25C3.36859 1.5962 3.7819 1.02627 4.33761 0.62202C4.89331 0.217774 5.56282 1.19936e-05 6.25 0H14.75C15.612 0 16.4386 0.34241 17.0481 0.951903C17.6576 1.5614 18 2.38805 18 3.25V11.838C18.0001 12.4798 17.8102 13.1072 17.4543 13.6412C17.0984 14.1753 16.5924 14.592 16 14.839V14.975C16 16.025 15.47 16.82 14.691 17.319C13.941 17.799 12.974 18.005 11.998 17.999H11.996L7.919 17.995H4C2.843 17.995 1.836 17.633 1.11 16.95C0.383 16.264 0 15.31 0 14.25V5.5C0 4.635 0.216 3.817 0.734 3.204C1.268 2.571 2.044 2.25 2.956 2.25H3.157ZM3 3.75H2.956C2.412 3.75 2.085 3.929 1.88 4.171C1.66 4.433 1.5 4.865 1.5 5.5V14.25C1.5 14.94 1.742 15.484 2.14 15.858C2.54 16.235 3.157 16.495 4 16.495H7.92L12 16.5H12.004C12.792 16.504 13.449 16.334 13.882 16.056C14.254 15.818 14.464 15.506 14.496 15.088H6.25C5.38805 15.088 4.5614 14.7456 3.9519 14.1361C3.34241 13.5266 3 12.7 3 11.838V3.75ZM6.25 1.5C5.78587 1.5 5.34075 1.68437 5.01256 2.01256C4.68437 2.34075 4.5 2.78587 4.5 3.25V11.838C4.5 12.805 5.284 13.588 6.25 13.588H14.75C15.2141 13.588 15.6592 13.4036 15.9874 13.0754C16.3156 12.7472 16.5 12.3021 16.5 11.838V3.25C16.5 2.78587 16.3156 2.34075 15.9874 2.01256C15.6592 1.68437 15.2141 1.5 14.75 1.5H6.25Z"
              fill="#0B93DF"
            />
          </svg>
        );
      case "youtube-play-button":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            fill={color}
            viewBox="0 0 43 31"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M42.0514 4.71563C41.8047 3.80411 41.3235 2.97312 40.6558 2.30542C39.988 1.63772 39.157 1.1566 38.2455 0.909987C34.9082 0 21.4783 0 21.4783 0C21.4783 0 8.04783 0.0276152 4.71112 0.937602C3.79964 1.18426 2.96867 1.66539 2.30097 2.33309C1.63328 3.00079 1.15214 3.83176 0.905487 4.74324C-0.103915 10.6726 -0.495525 19.707 0.933102 25.3989C1.17976 26.3104 1.66089 27.1413 2.32859 27.809C2.99629 28.4767 3.82726 28.9579 4.73874 29.2045C8.07571 30.1145 21.5059 30.1145 21.5059 30.1145C21.5059 30.1145 34.9361 30.1145 38.2731 29.2045C39.1846 28.9579 40.0155 28.4767 40.6832 27.809C41.3509 27.1413 41.8321 26.3104 42.0787 25.3989C43.1431 19.4614 43.4713 10.4325 42.0511 4.71589L42.0514 4.71563Z"
              fill="#FF0000"
            />
            <path d="M17.2036 21.511L28.3449 15.058L17.2036 8.60474V21.511Z" fill="white" />
          </svg>
        );
      case "avatar":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            fill={color}
            viewBox="0 0 40 40"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20 0C8.954 0 0 8.954 0 20C0 31.046 8.954 40 20 40C31.046 40 40 31.046 40 20C40 8.954 31.046 0 20 0ZM13 15C13 14.0807 13.1811 13.1705 13.5328 12.3212C13.8846 11.4719 14.4002 10.7003 15.0503 10.0503C15.7003 9.40024 16.4719 8.88463 17.3212 8.53284C18.1705 8.18106 19.0807 8 20 8C20.9193 8 21.8295 8.18106 22.6788 8.53284C23.5281 8.88463 24.2997 9.40024 24.9497 10.0503C25.5998 10.7003 26.1154 11.4719 26.4672 12.3212C26.8189 13.1705 27 14.0807 27 15C27 16.8565 26.2625 18.637 24.9497 19.9497C23.637 21.2625 21.8565 22 20 22C18.1435 22 16.363 21.2625 15.0503 19.9497C13.7375 18.637 13 16.8565 13 15ZM32.516 29.968C31.0189 31.8512 29.1156 33.3719 26.9483 34.4164C24.7811 35.4609 22.4058 36.0022 20 36C17.5942 36.0022 15.2189 35.4609 13.0517 34.4164C10.8844 33.3719 8.98113 31.8512 7.484 29.968C10.726 27.642 15.15 26 20 26C24.85 26 29.274 27.642 32.516 29.968Z"
              fill="#DEDEED"
            />
          </svg>
        );
      case "link":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M9.16666 4.16663H4.16666V15.8333H15.8333V10.8333"
              stroke="#0B93DF"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10.8333 9.16671L16.6666 3.33337"
              stroke="#0B93DF"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12.5 2.5H17.5V7.5"
              stroke="#0B93DF"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        );
      case "logo-icon":
        return (
          <svg
            {...rest}
            height={height || size}
            width={width || size}
            onClick={onClick}
            style={style}
            className={className}
            fill={color}
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_119_1863)">
              <path
                d="M16.875 2.94334C17.0233 2.90497 17.1794 2.90825 17.326 2.95284C17.4727 2.99742 17.6042 3.08158 17.7061 3.19605C17.808 3.31053 17.8763 3.45088 17.9036 3.60169C17.9309 3.75249 17.9161 3.90791 17.8608 4.05084L12.8608 16.9675C12.8113 17.0954 12.7311 17.2092 12.6271 17.2986C12.5231 17.3881 12.3987 17.4505 12.2648 17.4804C12.131 17.5102 11.9918 17.5066 11.8597 17.4697C11.7275 17.4329 11.6066 17.364 11.5075 17.2692L8.68913 14.5733L7.68662 15.575C7.15662 16.105 6.24996 15.73 6.24996 14.98V12.24L1.92412 8.1025C1.81679 7.99982 1.73886 7.87031 1.69839 7.72739C1.65792 7.58447 1.65639 7.43333 1.69396 7.28962C1.73152 7.14591 1.80681 7.01485 1.91204 6.91001C2.01727 6.80517 2.14861 6.73037 2.29246 6.69334L16.875 2.94334ZM15.1133 6.53084L8.44829 12.0367L11.7566 15.2017L15.1133 6.53084ZM13.7983 5.45584L4.15912 7.93334L7.23579 10.875L13.7983 5.45417V5.45584Z"
                fill="#0B93DF"
              />
            </g>
            <defs>
              <clipPath id="clip0_119_1863">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      default:
        return null;
    }
  }
}
